import { FunctionComponent, useState } from 'react';

import { Collapse } from '@savgroup-front-common/core/atoms/Collapse';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { Divider } from '@savgroup-front-common/core/protons/Divider/Divider';
import { DENSITY } from '@savgroup-front-common/core/protons/Divider/Divider.types';
import {
  ChevronDownIcon,
  ChevronUpIcon,
} from '@savgroup-front-common/core/protons/icons';

import { FileStateHistorySummary } from '@savgroup-front-common/core/api/Workflow/getFileStatesQuery';

import {
  $CollapsableButton,
  $FileHeader,
  $Header,
  $ItemWrapper,
} from './FileHistory.styles';
import FileHistoryCardRow from './FileHistoryItem/FileHistoryItem';
import messages from './messages';

const FileHistory: FunctionComponent<{
  histories: FileStateHistorySummary[] | undefined;
}> = ({ histories }) => {
  const [isCollapsed, setCollapsable] = useState(true);

  return (
    <div>
      <$Header>
        <$FileHeader>
          <SafeFormattedMessageWithoutSpread message={messages.titleCard} />
        </$FileHeader>
        <$CollapsableButton onClick={() => setCollapsable(!isCollapsed)}>
          {!isCollapsed && <ChevronDownIcon />}
          {isCollapsed && <ChevronUpIcon />}
        </$CollapsableButton>
      </$Header>
      <Divider density={DENSITY.COMFORTABLE} />
      <Collapse isOpen={isCollapsed} couldUnmountIfClosed={true}>
        {histories?.map((history) => (
          <FileHistoryCardRow
            key={history.stateDate.toString()}
            history={history}
          />
        ))}

        {histories?.length === 0 && (
          <$ItemWrapper>
            <SafeFormattedMessageWithoutSpread
              message={messages.emptyHistory}
            />
          </$ItemWrapper>
        )}
      </Collapse>
    </div>
  );
};

FileHistory.displayName = 'FileHistory';
export default FileHistory;
